import React from 'react'

const About = () => {
  return (
    <section className='section about-section'>
      <h1 className='section-title'>about</h1>
      <p>This is a page where you get dru... err... to know how to create cocktail drinks.</p>
      <p>API provided by https://www.thecocktaildb.com</p>
    </section>
  )
}

export default About
